import {
  WobaLogger,
  ConsoleTransport,
  DatadogTransport,
  ILogTransport,
} from "@woba/logger-web";

// Repo convention: gate on VITE_NODE_ENV, not import.meta.env.PROD.
const isProduction = import.meta.env.VITE_NODE_ENV === "production";
const datadogClientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;

// In production, log ONLY to Datadog — never the browser console (no request
// spam in users' consoles, and no console.error that RUM would double-capture).
// Outside production, log to the console for local visibility. The Datadog
// transport is guarded on token presence so a tokenless prod build stays silent
// rather than 401-ing on every flush.
const transports: ILogTransport[] = [];

if (isProduction) {
  if (datadogClientToken) {
    transports.push(
      new DatadogTransport({
        clientToken: datadogClientToken,
        service: "web-backoffice",
        env: import.meta.env.VITE_NODE_ENV || "development",
      }),
    );
  }
} else {
  transports.push(new ConsoleTransport());
}

export const wobaLogger = new WobaLogger({
  service: "web-backoffice",
  env: import.meta.env.VITE_NODE_ENV || "development",
  version: import.meta.env.VITE_APP_VERSION || "1.0.0",
  sensitiveFields: [
    "password",
    "token",
    "cpf",
    "creditCard",
    "cvv",
    "cardNumber",
  ],
  transports,
});
